import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import LinkButton from './LinkButton';

export class Inwards extends Component {
    static displayName = Inwards.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
        this.history = props.history;
    }

    componentDidMount() {
     }
    goto(page) {
        this.history.push(page);
    }
   
    render() {
        return <div className="container" >
            <h3>Customer Site</h3>
            <div className="row mb-3 ">
                <LinkButton className="btn btn-success col-12 mb-2" to="LoadPallet" >Load Pallet</LinkButton>
                <LinkButton className="btn btn-success col-12 mb-2" to="LoadTruck" >Load Trunk</LinkButton>
            </div>
            <h3>SCS Warehouse</h3>
            <div className="form-group row mb-3">
                <LinkButton className="btn btn-primary col-12 mb-2" to="UnloadTruck" >Unload Truck</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="TotePutaway" >Put Away</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="ToteApproval" >Tote Approval</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="CartonisedInwards/CartonisedChooseShipment" >Cartonised Receipting</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="LinenhouseXdoc/LH_LoadOpenASN" >Linenhouse Crossdock</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="SCSInwards/ReceivedShipments" >Shipment Image Capture</LinkButton>
            </div>
            </div>
    }

  
}
